import React, { PureComponent } from 'react';
import { DatePicker } from 'antd';
import moment, { Moment, isMoment } from 'moment';
import classNames from 'classnames/bind';

import { RangePickerValue } from 'antd/lib/date-picker/interface';
import styles from './index.less';

const { MonthPicker, RangePicker } = DatePicker;
const cx = classNames.bind(styles);

const configInit: Array<string | number> = ['today', 6, 14, 29];
// const configInit: Array<string | number> =
// ['today', 'yesterday', 'week', 7, 15, 'month', 30, 60];
const defaultProps = {
  label: '',
  gutter: 6,
  mode: 'horizontal',
  defaultValue: [] as RangePickerValue,
  config: configInit,
  format: 'YYYY-MM-DD' as string,
  onChange: (
    date: RangePickerValue,
    dateString: string[],
    key?: string | number,
    tip?: string
  ) => {},
  showDay: true, // 显示单日
  showMonth: true, // 显示单月
  showRange: true, // 显示选择范围
  showQuick: true, // 显示快捷操作
  allowClear: true, // 显示清除按钮
};
const initialState = {
  date: [] as RangePickerValue,
  dateString: [] as string[],
};

type State = Readonly<typeof initialState>;
type DefaultProps = typeof defaultProps;
type Props = DefaultProps;

const selectConf: any = {
  6: '最近一周',
  14: '最近15日',
  29: '最近一月',
  364: '最近一年',
  today: '今日',
  yesterday: '昨日',
  week: '本周',
  month: '本月',
  year: '本年',
};

export const isNow = (key: any, date: RangePickerValue) => {
  if (!date || !date[0] || !date[1]) {
    return false;
  }
  const day = Number(key);
  const start = date[0].format('YYYY-MM-DD');
  const end = date[1].format('YYYY-MM-DD');
  const now = moment().format('YYYY-MM-DD');
  const days = date[1].diff(date[0], 'days');
  if (!Number.isNaN(day) && end === now) {
    return days === day;
  }
  if (key === 'today') {
    return !days && start === now;
  }
  if (key === 'yesterday') {
    return (
      !days &&
      start ===
        moment()
          .startOf('day')
          .subtract(1, 'days')
          .format('YYYY-MM-DD')
    );
  }
  return (
    !!selectConf[key] &&
    start ===
      moment()
        .startOf(key)
        .format('YYYY-MM-DD') &&
    end ===
      moment()
        .endOf(key)
        .format('YYYY-MM-DD')
  );
};
export const getDateAbbr = (date: RangePickerValue, format: string = 'YYYY-MM-DD') => {
  return Object.keys(selectConf).reduce(
    (acc, c) => (isNow(c, date) ? selectConf[c] : acc),
    date[0] && date[1] ? `${date[0].format(format)}~${date[1].format(format)}` : ''
  );
};

export default class DokDatePicker extends PureComponent<Props, State> {
  static defaultProps = defaultProps;
  readonly state = initialState;

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps: Props) {
    const { format } = this.props;
    const default1 = prevProps.defaultValue;
    const default2 = this.props.defaultValue;
    const sday1 = default1 && default1[0] ? default1[0].format(format) : '';
    const eday1 = default1 && default1[1] ? default1[1].format(format) : '';
    const sday2 = default2 && default2[0] ? default2[0].format(format) : '';
    const eday2 = default2 && default2[1] ? default2[1].format(format) : '';
    if (sday1 !== sday2 || eday1 !== eday2) {
      this.init();
    }
  }

  render() {
    const {
      mode,
      label,
      config = configInit,
      gutter,
      showDay,
      showMonth,
      showRange,
      showQuick,
      allowClear,
    } = this.props;
    const { date } = this.state;

    const isToday = date && date[0] && date[1] && (date[0] || moment()).isSame(date[1], 'day');
    const isMonth =
      date &&
      !!date[0] &&
      !!date[1] &&
      date[1].diff(date[0], 'days') === date[0].daysInMonth() - 1 &&
      date[0].format('YYYY-MM') === date[1].format('YYYY-MM');

    return (
      <>
        {!!label && (
          <div className={styles.tag} style={{ cursor: 'initial' }}>
            {label}:
          </div>
        )}
        <div className={cx({ [styles.inline]: mode === 'horizontal' })}>
          {showQuick &&
            config.map((v: any, i: number) => (
              <div
                key={v}
                onClick={this.handleClick(v)}
                style={{ marginRight: mode === 'horizontal' || i < config.length - 1 ? gutter : 0 }}
                className={`${styles.tag} ${this.isNow(v) ? styles.on : ''}`}
              >
                {selectConf[v] || `最近${v + 1}日`}
              </div>
            ))}
        </div>
        {showDay && (
          <DatePicker
            size="small"
            allowClear={allowClear}
            placeholder="点击选日期"
            className={styles.date}
            style={{ marginRight: mode === 'horizontal' ? gutter + 8 : 8 }}
            value={isToday ? date[0] : undefined}
            onChange={this.handleSelect('day')}
          />
        )}
        {showMonth && (
          <MonthPicker
            size="small"
            allowClear={allowClear}
            placeholder="点击选月份"
            className={styles.date}
            value={isMonth ? date[0] : undefined}
            onChange={this.handleSelect('month')}
            style={{ marginRight: mode === 'horizontal' ? gutter + 8 : 0 }}
          />
        )}
        {showRange && (
          <div className={cx({ [styles.inline]: mode === 'horizontal' })}>
            {mode === 'horizontal' && <span className={styles['range-text']}>自定义：</span>}
            <RangePicker
              size="small"
              value={date}
              allowClear={allowClear}
              placeholder={['开始时间', '结束时间']}
              className={styles['range-date']}
              onChange={this.handleSelect()}
              style={{ width: mode === 'horizontal' ? 200 : 208 }}
            />
          </div>
        )}
      </>
    );
  }
  init = () => {
    const { defaultValue, format } = this.props;
    const prevDate = this.state.date;
    if (defaultValue && defaultValue.length && defaultValue[0]) {
      const date: RangePickerValue = [defaultValue[0], defaultValue[1] || defaultValue[0]];
      const dateString: string[] = defaultValue[0]
        ? [defaultValue[0].format(format), (defaultValue[1] || defaultValue[0]).format(format)]
        : [];
      if (dateString.join() !== this.state.dateString.join()) {
        this.setState({ date, dateString });
      }
    } else if (prevDate && prevDate.length) {
      this.setState({ date: [], dateString: [] });
    }
  };
  handleClick = (key: string) => {
    return () => {
      const { allowClear } = this.props;
      const day: number = Number(key);
      let date: RangePickerValue = [];
      if (!this.isNow(key)) {
        if (Number.isNaN(day)) {
          if (key === 'yesterday') {
            date = [
              moment()
                .startOf('day')
                .subtract(1, 'days'),
              moment()
                .endOf('day')
                .subtract(1, 'days'),
            ];
          } else if (!!selectConf[key]) {
            const k: any = key === 'today' ? 'day' : key;
            date = [moment().startOf(k), moment().endOf(k)];
          }
        } else {
          date = [moment().subtract(day, 'days'), moment()];
        }
        this.handleChange(date);
      } else if (allowClear) {
        this.handleChange(date);
      }
    };
  };
  handleSelect = (key?: any) => {
    return (v: RangePickerValue | Moment | null) => {
      if (!v || (!isMoment(v) && !isMoment(v[0]))) {
        this.handleChange([]);
      } else {
        this.handleChange(
          isMoment(v) && key
            ? [
                moment(v.startOf(key).format('YYYY-MM-DD')),
                moment(v.endOf(key).format('YYYY-MM-DD')),
              ]
            : !isMoment(v)
            ? v
            : []
        );
      }
    };
  };
  handleChange = (date: RangePickerValue) => {
    const { onChange, format, config } = this.props;
    if (date && date[0] && date[1]) {
      const dateString: string[] = [date[0].format(format), date[1].format(format)];
      this.setState({ date, dateString }, () => {
        const txt = config.reduce(
          (acc, c) => (this.isNow(c) ? [c, selectConf[c] || `最近${Number(c || 0) + 1}日`] : acc),
          ['', `${dateString[0]}~${dateString[1]}`]
        );
        onChange && onChange(date, dateString, ...txt);
      });
    } else {
      this.setState({ date: [], dateString: [] });
      onChange && onChange([], [], '', '');
    }
  };
  isNow(key: any) {
    const { date } = this.state;
    return isNow(key, date);
  }
}
